module.exports = __webpack_public_path__ + "img/TechHunting1_ua.62876f62.webp";